/**
 * Historically installed GA4's gtag.js directly from React using a Measurement ID
 * stored in Site Settings. Google Tag Manager (GTM-TGKLNJS, installed statically in
 * index.html) now owns loading GA4 via its own "Google Tag" tag — leaving this
 * component's injection in place too would load gtag.js twice and double-count every
 * pageview. Kept as a harmless pass-through rather than unwinding its usage out of
 * App.tsx's provider tree, since there's nothing left for it to actually do.
 */
const AnalyticsProvider = ({ children }: { children: React.ReactNode }) => {
  return <>{children}</>;
};

export default AnalyticsProvider;